import './Icon.css';
import { IconProps } from './iconType';

export const ArrowIcon: React.FC<IconProps> = ({
  size = 12,
  color,
  className,
}) => {
  return (
    <span
      className={['icon', className].filter(Boolean).join(' ')}
      style={{ width: size, height: size, color }}
    >
      <svg
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M11.8301 6.1231C11.6225 5.94141 11.3069 5.96266 11.125 6.16997L7.62502 10.17C7.46008 10.3585 7.46009 10.6397 7.62502 10.8282L11.125 14.8282C11.3069 15.0359 11.6223 15.0569 11.8301 14.875C12.0374 14.6931 12.0587 14.3776 11.877 14.17L8.66506 10.4991L11.877 6.82817C12.0583 6.62039 12.0377 6.30482 11.8301 6.1231Z'
          fill='#5D5D5D'
        />
      </svg>
    </span>
  );
};
